/**
 * Description:系统配置项 包含title/标题/IM/个人资产等
 * Created by wxy on 2018/11/21
 */
import {configList, getLogo} from '@/api/systemManagement/configurationApi'

const systemConfig = {
  state: {
    info: null,
    name: '',
    title: '',
    logo: '',
    IM: '',
    asset: '',
    FileView: ''
  },
  mutations: {
    SET_INFO: (state, info) => {
      state.info = info
      document.title = info.title ? info.title : '紫光云-用户平台'
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_TITLE: (state, title) => {
      state.title = title || state.info.title || '紫光云-用户平台'
      document.title = state.title
    },
    SET_LOGO: (state, logo) => {
      state.logo = logo
    },
    SET_IM: (state, IM) => {
      state.IM = Number(IM)
    },
    SET_ASSET: (state, asset) => {
      state.asset = Number(asset)
    },
    SET_FileView: (state, FileView) => {
      state.FileView = FileView
    }
  },
  actions: {
    // 获取配置信息
    GetConfigList ({commit, state}) {
      return new Promise((resolve, reject) => {
        configList().then(res => {
          if (res.status === 200) {
            const configData = res.data.data
            let logo = configData.logo ? window.location.protocol + '//' + window.location.host + configData.logo : ''
            commit('SET_INFO', configData)
            commit('SET_NAME', configData.name)
            commit('SET_TITLE', configData.title)
            commit('SET_LOGO', logo)
            commit('SET_IM', configData.IM)
            commit('SET_ASSET', configData.asset)
            commit('SET_FileView', configData.FileView)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    setTitleForUworkerPc ({commit}, title) {
      commit('SET_TITLE', title)
    },
    // 获取配置信息
    GetLogo ({commit, state}) {
      return new Promise((resolve, reject) => {
        getLogo().then(res => {
          if (res.status === 200) {
            let logo = res.data.data ? window.location.protocol + '//' + window.location.host + res.data.data : ''
            commit('SET_LOGO', logo)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default systemConfig



// WEBPACK FOOTER //
// ./src/store/modules/config.js